<template>
  <div v-if="products.length === 0">
    <h4 class="text-center text-2xl">
      Hier ist richtig viel Platz für deine Wohnideen.
    </h4>
    <p class="text-center text-sm">
      Lass dich inspirieren und fülle deinen Wunschzettel mit tollen Produkten.
    </p>
    <div class="flex p-1">
      <router-link
        to="/"
        class="mx-auto px-4 py-1 text-center font-semibold bg-teal-400 text-white rounded hover:text-teal-400 hover:bg-white"
        >Jetzt im Shop stöbern</router-link
      >
    </div>
  </div>
  <div v-else>
    <div>
      <h1 class="text-3xl text-gray-800 font-semibold">
        Mein Wunschzettel
        <span class="text-sm font-normal text-gray-600">
          Speichern Sie hier alle Produkte, die perfekt in Ihr Zuhause passen
        </span>
        </h1>
        <div class="py-4">
          <hr class="">
        </div>
    </div>
    <div
      class="max-w-sm pt-3 w-full lg:max-w-full lg:flex py-2"
      v-for="product in products"
      :key="product.id"
    >
      <div
        class="h-48 lg:h-auto lg:w-48 flex-none bg-cover rounded-t lg:rounded-t-none lg:rounded-l text-center overflow-hidden"
      >
        <img
          class="object-cover"
          :src="product.product_shop.product.product_image"
          alt="Product Cart Image"
        />
      </div>
      <div
        class="bg-white rounded-b lg:rounded-b-none lg:rounded-r px-4 flex flex-col justify-between leading-normal"
      >
        <div class>
          <p class="text-sm text-gray-600 flex items-center"></p>
          <div class="text-gray-700 font-semibold text-xl">
            {{ product.product_shop.name }}
            <span class="text-base pl-5">
              <button @click="deleteProduct(product.id)">
                <i class="fa fa-trash"></i>
              </button>
            </span>
          </div>
          <p class="text-teal-400 font-bold text-2xl">
            {{ product.price | formatNumber }}
            <span class="text-gray-700 text-base font-normal">Inkl. MwSt.</span>
          </p>
          <div>
            Lieferzeit:
              <span
                v-if="product.product_shop.product.stock > 0"
                class="text-teal-400 font-bold"
                >
                1-2 Wohen
                <!-- {{ product.product_shop.product.delivery_weeks }} -->
                </span
              >
          </div>
          <div>
            <span class="text-gray-700">
              Vom:
              <span class="text-teal-400">{{product.product_shop.shop_name}}</span>
            </span>
          </div>
          <button @click="addToCart(product)" class="bg-teal-400 text-xl text-white rounded px-8 py-1 my-4  mr-2 hover:text-teal-400 hover:bg-white">
            {{ $t("AddToCart") }}
          </button>
        </div>
        <div>
          <hr>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import mixins from "@/mixins/mixins";

export default {
  mixins: [mixins],

  data() {
    return {
      products: [],
    };
  },
  created() {
    this.getProducts();
  },
  methods: {
    getProducts() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios
        .get(`${process.env.VUE_APP_API}/wishlist`)
        .then((response) => {
          // console.log(response);
          this.products = response.data.data.products;
        })
        .catch((error) => console.log(error));
    },
    
    deleteProduct(id) {
      let item = this.products.find((item) => {
        return item.id === id;
      });

      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios
        .delete(`${process.env.VUE_APP_API}/wishlist/${item.id}`)
        .then(() => {})
        .catch((error) => {
          console.log(error);
        });

      this.getProducts();
      // console.log(item.id);
    },

  },
};
</script>

<style></style>
